import React from "react";

import {UiState} from "../../../ui-state";

import {AppState} from "../../../../stores/app-mobx";
import {Icon} from "../../icon/icon";
import AreaMeasurement2D from "@arcgis/core/widgets/AreaMeasurement2D";
import DistanceMeasurement2D from "@arcgis/core/widgets/DistanceMeasurement2D";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import {autorun} from "mobx";

interface MeasurementProperties {
    appStore: AppState;
    small?: boolean;
    uiStore: UiState;
    view: __esri.MapView | __esri.SceneView | undefined;
}
interface MeasurementStates {
    active: boolean;
    activeTool?: "area" | "distance";
}

export class Measurement extends React.Component<MeasurementProperties, any> {
    state: MeasurementStates;
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    measurements: Array<AreaMeasurement2D | DistanceMeasurement2D>;
    measurementRefs: Array<React.RefObject<any>>;
    widgetKey = "measurement";
    constructor(props: MeasurementProperties) {
        super(props);
        this.state = {
            active: false,
            activeTool: undefined
        };
        this.measurements = [];
        this.measurementRefs = [];
        this.measurementRefs["area"] = React.createRef();
        this.measurementRefs["distance"] = React.createRef();
        if (typeof this.props.small === "boolean" && this.props.small) {
            this.widgetKey += "-small";
        }
        this.close = this.close.bind(this);
    }
    setActive(active: boolean, tool?: "area" | "distance"): void {
        const {view} = this.props;
        if (!view) {
            return;
        }
        if (active){
            if (!tool) {
                tool = this.state.activeTool;
            }
            if (this.state.activeTool && this.measurements[this.state.activeTool]) {
                this.measurements[this.state.activeTool].viewModel.clear();
                this.measurements[this.state.activeTool].visible = false;
            }
            if (tool === "area") {
                if (!this.measurements[tool]) {
                    this.measurements[tool] = new AreaMeasurement2D({
                        container: this.measurementRefs[tool].current,
                        view,
                        id: this.widgetKey,
                        unitOptions: ["metric", "square-meters", "square-kilometers", "ares", "hectares"]
                    });
                }
                this.measurements[tool].visible = true;
            } else if (tool === "distance") {
                if (!this.measurements[tool]) {
                    this.measurements[tool] = new DistanceMeasurement2D({
                        container: this.measurementRefs[tool].current,
                        view,
                        id: this.widgetKey,
                        unitOptions : ["metric", "meters", "kilometers"]});
                }
                this.measurements[tool].visible = true;
            }

            if (tool === "distance" || tool === "area") {
                this.watchHandles.push(reactiveUtils.when(
                    () => tool && this.measurements[tool].viewModel.state === "ready",
                    () => {
                        if (tool === "distance" || tool === "area") {
                            this.measurements[tool]?.viewModel.start();
                        }
                    },
                    { initial: true, once: true }
                ));
            }
        } else {
            if (this.measurements["area"]) {
                this.measurements["area"].viewModel.clear();
                this.measurements["area"].visible = false;
            }
            if (this.measurements["distance"]) {
                this.measurements["distance"].viewModel.clear();
                this.measurements["distance"].visible = false;
            }
        }
    }
    close(): void {
        const {uiStore} = this.props;
        uiStore.PopupStore.setDisabled(false);
        uiStore.setActiveTool("");
    }
    componentDidMount(): void {
        autorun(() => {
            const {uiStore} = this.props;
            if (uiStore.activeTool.indexOf("measurement")===0) {
                const activeTool = uiStore.activeTool.substring(12);
                if (activeTool === "distance" || activeTool === "area"){
                    this.setState({active: true, activeTool});
                    this.setActive(true, activeTool);
                }
            } else {
                this.setActive(false);
                this.setState({active: false});
            }
        });
    }
    componentWillUnmount(): void {
        const {uiStore, view} = this.props;
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
        if (view) {
            if (this.measurements["area"]) {
                this.measurements["area"].destroy();
            }
            if (this.measurements["distance"]) {
                this.measurements["distance"].destroy();
            }
        }
        uiStore.removeWidget(this.widgetKey);
    }

    render(): JSX.Element | null {
        const {active} = this.state;
        return (
            <div className={"geo-measurement-wrapper geo-widget geo-component"+(active? " show": " hidden")}>
                <div ref={this.measurementRefs["area"]} />
                <div ref={this.measurementRefs["distance"]} />
                <Icon name={"navigate_cross"} onClick={this.close} className={"geo-close"} />
            </div>
        );
    }
}
